module.exports = __webpack_public_path__ + "static/media/edit-pencil-black.b337117f.svg";